import { Games } from '@/constants'
import cookie from 'vue-cookie'

const BASE_URL = 'https://mg.apineural.com/api/goods'
const VERSION = '1'

const GAME_TO_SLUG = {
  [Games.ADOPTME]: 'adoptme',
  [Games.ANIME_RANGERS]: 'anime-rangers',
  [Games.BLADE_BALL]: 'blade-ball',
  [Games.BLOX_FRUITS]: 'blox-fruits',
  [Games.BLUE_LOCK]: 'blue-lock',
  [Games.BRAINROT_EVOLUTION]: 'brainrot-evolution',
  [Games.BROOKHAVEN]: 'brookhaven',
  [Games.DRESS_IMPRESS]: 'dress-impress',
  [Games.FISCH]: 'fisch',
  [Games.FISH_IT]: 'fish-it',
  [Games.FORSAKEN]: 'forsaken',
  [Games.GARDEN]: 'growgarden',
  [Games.MURDER_MYSTERY]: 'murder_mystery',
  [Games.NIGHTS_FOREST]: 'nights-forest',
  [Games.PET_SIMULATOR_99]: 'pet-simulator-99',
  [Games.PLANTS_BRAINROT]: 'plants-brainrot',
  [Games.RIVALS]: 'rivals',
  [Games.STEAL_BRAINROT]: 'steal-brainrot',
  [Games.STRONGEST_BATTLEGROUNDS]: 'strongest-battlegrounds',
  [Games.UNIVERSAL_TIME]: 'universal-time',
  [Games.ESCAPE_TSUNAMI]: 'tsunami',
  [Games.SAILOR_PIECE]: 'sailor-piece',
  [Games.GRAND_PIECE_ONLINE]: 'grand-piece-online',
  [Games.DA_HOOD]: 'da-hood',
  [Games.GARDEN2]: 'growgarden2'
}

const GAME_TO_CDN_SLUG = {
  [Games.ADOPTME]: 'AM',
  [Games.ANIME_RANGERS]: 'ANIME_RANGERS',
  [Games.BLADE_BALL]: 'BLADE_BALL',
  [Games.BLOX_FRUITS]: 'BLOX_FRUITS',
  [Games.BLUE_LOCK]: 'BLUE_LOCK',
  [Games.BRAINROT_EVOLUTION]: 'BRAINROT_EVOLUTION',
  [Games.BROOKHAVEN]: 'BROOKHAVEN',
  [Games.DRESS_IMPRESS]: 'DRESS_IMPRESS',
  [Games.FISCH]: 'FISCH',
  [Games.FISH_IT]: 'FISH_IT',
  [Games.FORGE]: 'FORGE',
  [Games.FORSAKEN]: 'FORSAKEN',
  [Games.GARDEN]: 'GG',
  [Games.MURDER_MYSTERY]: 'MM',
  [Games.NIGHTS_FOREST]: 'NIGHTS_FOREST',
  [Games.PET_SIMULATOR_99]: 'PET_SIMULATOR_99',
  [Games.PLANTS_BRAINROT]: 'PB',
  [Games.RIVALS]: 'RIVALS',
  [Games.STEAL_BRAINROT]: 'SB',
  [Games.STRONGEST_BATTLEGROUNDS]: 'STRONGEST_BATTLEGROUNDS',
  [Games.UNIVERSAL_TIME]: 'UNIVERSAL_TIME',
  [Games.ESCAPE_TSUNAMI]: 'ESCAPE_TSUNAMI',
  [Games.SAILOR_PIECE]: 'SAILOR_PIECE',
  [Games.GRAND_PIECE_ONLINE]: 'GRAND_PIECE_ONLINE',
  [Games.DA_HOOD]: 'DA_HOOD',
  [Games.GARDEN2]: 'GG2'
}

export async function getGoodsList({ page, limit, name, game }) {
  const body = {
    page,
    limit,
    sorting: {
      field: 'created_at',
      direction: 'asc'
    }
  }

  if (name) {
    body.name = name
  }

  if (game) {
    body.game = game
  } else {
    body.game = Games.ADOPTME
  }

  const response = await fetch(`${BASE_URL}/list`, {
    method: 'POST',
    headers: prepareHeaders({}),
    body: prepareBody(body)
  })
  const data = await response.json()

  if (data.error) {
    throw data.error
  }

  return data.data
}

export async function getGoodsFields(game) {
  const response = await fetch(`${BASE_URL}/${GAME_TO_SLUG[game]}/features`, {
    method: 'GET',
    headers: prepareHeaders({})
  })
  const data = await response.json()

  if (data.error) {
    throw data.error
  }

  return data.data
}

export async function createGoods(game, requestData) {
  const response = await fetch(`${BASE_URL}/${GAME_TO_SLUG[game]}/create`, {
    method: 'POST',
    headers: prepareHeaders({
      'X-Version': '2'
    }),
    body: prepareBody(requestData)
  })
  const data = await response.json()

  if (data.error) {
    throw data.error
  }

  return data.data
}

export async function getGoodDetails(goodId) {
  const response = await fetch(`${BASE_URL}/${goodId}/details`, {
    method: 'GET',
    headers: prepareHeaders({})
  })
  const data = await response.json()

  if (data.error) {
    throw data.error
  }

  return data.data
}

export async function updateGoodVariant(goodId, requestData) {
  const response = await fetch(`${BASE_URL}/variant/${goodId}`, {
    method: 'PUT',
    headers: prepareHeaders({}),
    body: prepareBody(requestData)
  })
  const data = await response.json()

  if (data.error) {
    throw data.error
  }

  return data.data
}

export async function updateGoodGroup(groupId, requestData) {
  const response = await fetch(`${BASE_URL}/groups/${groupId}`, {
    method: 'PUT',
    headers: prepareHeaders({}),
    body: prepareBody(requestData)
  })
  const data = await response.json()

  if (data.error) {
    throw data.error
  }

  return data.data
}

export function getGoodImageUrl(imageId, game) {
  return `https://cdn.starpets.pw/${GAME_TO_CDN_SLUG[game]}/110x110/${imageId}.webp`
}

function prepareBody(body) {
  return JSON.stringify(body)
}

function prepareHeaders(headers) {
  return {
    'X-Version': VERSION,
    'Content-Type': 'application/json',
    Authorization: `Bearer ${cookie.get('token')}`,
    ...headers
  }
}
